import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerPostApi('deleteFiles', async (request) => {
  const { fileIds } = request
  const deletedIds: string[] = []

  for (const fileId of fileIds) {
    if (filesMem[fileId]) {
      // If it's a folder, recursively delete all children
      if (filesMem[fileId].type === 'folder') {
        const childrenToDelete = Object.values(filesMem)
          .filter(file => file.path.startsWith(filesMem[fileId].path + '/'))
          .map(file => file.id)

        for (const childId of childrenToDelete) {
          delete filesMem[childId]
          deletedIds.push(childId)
        }
      }

      delete filesMem[fileId]
      deletedIds.push(fileId)
    }
  }

  return { success: true, deletedIds }
})